"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getOversValue = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    const currentValue = props.currentValue.toString();
    const dec = currentValue.search(/\./);
    const oversValue = dec > -1 ? Number(currentValue.substr(0, dec)) : Number(currentValue);
    const ballValue = dec > -1 ? Number(currentValue.substr(currentValue.length - 1)) : 0;
    let result = '';
    if (dec > -1 || props.undo) {
        if (props.oversOnly) {
            result = oversValue;
        }
        else if (props.endOver) {
            if (props.ballDisplayNum && ballValue < props.ballDisplayNum - 1 && props.ballDisplayNum <= props.ballsPerOver) {
                result = (Number(currentValue) + 0.1).toFixed(1);
            }
            else {
                result = oversValue + 1;
            }
        }
        else {
            if (props.undo && (dec === -1 || (dec > -1 && ballValue === 0))) {
                const undoBallValue = props.ballDisplayNum !== undefined && props.ballDisplayNum < props.ballsPerOver
                    ? props.ballDisplayNum - 1
                    : props.ballsPerOver - 1;
                result = oversValue - 1 + '.' + undoBallValue;
            }
            else if (props.undo && ballValue > 1) {
                result = (Number(currentValue) - 0.1).toFixed(1);
            }
            else if (props.undo && ballValue === 1) {
                result = oversValue + '.0';
            }
            else if (props.ballDisplayNum !== undefined &&
                props.ballDisplayNum !== ballValue &&
                ballValue >= props.ballsPerOver - 1 &&
                props.ballDisplayNum < props.ballsPerOver) {
                result = oversValue + 1 + `.${ballValue - (props.ballsPerOver - 1)}`;
            }
            else {
                if (props.ballDisplayNum !== undefined && props.ballDisplayNum > props.ballsPerOver) {
                    result = Number(oversValue + '.' + (props.ballDisplayNum + 1)).toFixed(1);
                }
                else {
                    result = Number(oversValue + '.' + (ballValue + 1)).toFixed(1);
                }
            }
        }
    }
    else {
        result = props.oversOnly ? currentValue : currentValue + '.1';
    }
    return Number(result);
};
exports.default = getOversValue;
//# sourceMappingURL=getOversValue.js.map